/**
 * Created by hp on 2017/8/9.
 */
import React, {Component} from 'react';
import {LoadMore} from 'react-weui';

class WKPreload extends Component {
    render() {
        return (
            <div className="wk-preload wk-screen-center">
                <LoadMore loading/>
            </div>
        )
    }
}

export default WKPreload


// WEBPACK FOOTER //
// ./src/components/wk/WKPreload.js